import gql from 'graphql-tag';

const WDT_CLASSROOM_OVERALL_PROGRESS_QUERY = gql`
  query wdtClassroomOverallProgressReport($where: WdtClassroomOverallProgressReportWhereInput!) {
    wdtClassroomOverallProgressReport(where: $where) {
      totalStudentCount
      progress {
        module
        level
        charactersCompletedCount
      }
    }
  }
`;

export default WDT_CLASSROOM_OVERALL_PROGRESS_QUERY;
